import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  LoadingController,
  App,
  Scroll,
  AlertController,
  ModalController,
  Events
} from "ionic-angular";
import { RequestServiceProvider } from "../../providers/request-service/request-service";
import { LoginPage } from "../login/login";
import * as moment from "moment";
import { TabsPage } from "../tabs/tabs";
import { TransactionAlertProvider } from "../../providers/transaction-alert/transaction-alert";
import { LoadingProvider } from "../../providers/loading/loading";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  @ViewChild("scrollWeb") scrollWeb: Scroll;

  agentInfo: Object = {};
  agentBalance: Object = {};
  public loader;
  public transactions = [];
  public transHistory = [];
  public loadingStatus = {history: false, transactions: false};
  public debit = false;
  public status = false;
  public printer = {};

  public record = new Date().toISOString();
  public tabs = ["Transactions", "Income History"];
  public mode;

  constructor(
    public navCtrl: NavController,
    private request: RequestServiceProvider,
    private loading: LoadingController,
    private app: App,
    private alertCtrl: AlertController,
    private alert: TransactionAlertProvider,
    private event: Events,
    private load: LoadingProvider
  ) {
    // this.setMode(this.tabs[0]);
    // printer connected event listener.
    this.event.subscribe('printer-connected', (data) => {
      this.printer = data;
      this.status = data.status;
    });

    this.event.subscribe('printer-disconnected', data => {
      this.printer = {};
      this.status = data;
    });

    this.presentLoading("Loading Agent info...");
    Promise.all([this.getAgentInfo(), this.getAccountInfo()])
      .then(() => {
        this.hideLoading()
      })
      .catch(error => {
        if (error.status == 500) {
          this.hideLoading();
          this.logout();
        }
        if (error) {
          this.hideLoading();
          this.request.logout();
        }
      });
  }

  getAgentInfo() {
    return this.request.getAgentInfo().toPromise().then(data => {
      let agent = JSON.parse(data);
      this.agentInfo = agent;
      window.localStorage.setItem("agentId", agent.id);
      window.localStorage.setItem("agentCode", agent.realId);
      window.localStorage.setItem("agentObj", JSON.stringify(agent));
      this.event.publish("agent-info", this.agentInfo);
    });
  }

  getAccountInfo() {
    return this.request.getAccInfo().toPromise().then(data => {
      this.agentBalance = data;
      this.getProfileImg();
    });
  }

  setTransactions(transactions, fresh = true) {
    this.transactions = fresh ? transactions : [...this.transactions, ...transactions];
  }

  setHistories(histories, fresh = true) {
    this.transHistory = fresh ? histories : [...this.transHistory, ...histories];
  }

  getTransactions(from = 0, fresh = false, showLoader = false, successCallback = undefined, failureCallback = undefined) {
   this.getData(from, fresh, showLoader, 'transactions', successCallback, failureCallback); 
  }
  
  getHistories(from = 0, fresh = false, showLoader = false, successCallback = undefined, failureCallback = undefined) {
   this.getData(from, fresh, showLoader, 'history', successCallback, failureCallback); 
  }

  getData(from = 0, fresh = false, showLoader = false, type: 'transactions' | 'history' = 'transactions', successCallback = undefined, failureCallback = undefined) {
    const config = {
      history:{flag: 'history', setter: 'setHistories', method: 'getTransactionsHistoryByMonth'},
      transactions: {flag: 'transactions', setter: 'setTransactions', method: 'getTransactionsByMonth'},
    };
    const date = Date.parse(this.record);
    showLoader && this.presentLoading("Loading Transactions");
    this.loadingStatus[config[type].flag] = true;
    const success = data => {
      let d;
      if (successCallback ){
        let callbackData = successCallback();
        d =  callbackData || data;
      } else d = data;
      this[config[type].setter](d, fresh);
      showLoader && this.hideLoading();
      this.loadingStatus[config[type].flag] = false;
    };

    const error = error => {
      if(failureCallback ){
        failureCallback()
      } else {
        showLoader && this.hideLoading();
        if (error.json().code == 403) {
          this.request.logout();
        }
      }
      this.loadingStatus[config[type].flag] = false;
    };

    this.request[config[type].method](date, date, from).subscribe(success, error);
  }

  handleTabClick(mode){
    this.setMode(mode);
    if(mode == 'Income History')
     !this.loadingStatus.history && !this.transHistory.length && this.getHistories();
    else !this.loadingStatus.transactions && !this.transactions.length && this.getTransactions();
  }

  setMode(mode) {
    this.mode = mode;
  }

  transStatus(credit) {
    if (credit) return "Income";
    return "Debit";
  }

  showReciept(transaction) {
    this.alert.presentRecieptAlert(transaction, ()=>{});
  }


  getProfileImg() {
    return this.request
      .getAgentProfileImg(window.localStorage.getItem("agentCode"))
      .subscribe(
        data => {
           data && this.event.publish("profile-image", data.image_string);  
        },
        error => {}
      );
  }

  fetchMonthRecord(event) {
    if (this.mode === "Transactions") {
      this.getTransactions(0, true, true);
    }
    if (this.mode === "Income History") {
      this.getHistories(0, true, true);
    }
  }

  presentLoading(content = "") {
    this.loader = this.loading.create({ content });
    this.loader.present();
  }

  hideLoading(all = false) {
    this.loader && this.loader[all ? "dismissAll" : "dismiss"]();
  }

  logout() {
    this.request.logout();

    this.app.getRootNav().setRoot(LoginPage);
  }

  doInfinite(event) {
    const type = this.mode == 'Transactions' ? 'transactions' : 'history';
    const dataSource = this[type == 'transactions' ? 'transactions' : 'transHistory'];
    const flag = this.loadingStatus[type == 'transactions' ? 'transactions' : 'history'];
    !flag && this.getData(dataSource.length, false, false, type, () => {event.complete()});
  }

  getDate(date) {
    return moment(date).fromNow();
  }

  getTransColor(transaction) {
    if (transaction) return true;
    return false;
  }

  refreshPage() {
    this.navCtrl.setRoot(TabsPage);
  }

  getPage(page: string) {
    this.navCtrl.push(page);
  }

  withdraw() {
    this.alert.presentMoveIcomeAlert('Are you sure, you want to move your Income');
  }

  presentLogOutConfirm() {
    let alert = this.alertCtrl.create({
      title: "",
      message: "Do you want to logout",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {}
        },
        {
          text: "Logout",
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    alert.present();
  }

  naira(number) {
    return Number(number || 0).toLocaleString("en-NG", {
      currency: "NGN",
      currencyDisplay: "symbol",
      style: "currency"
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts